import Modal from "react-modal";

const AddAnotherDishModal = ({ isOpen, onYes, onNo }) => {
  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onNo}
      contentLabel="Add Another Dish"
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        content: {
          position: "relative",
          inset: "auto",               
          maxWidth: "420px",
          width: "90%",
          maxHeight: "90vh",          
          padding: "24px",
          borderRadius: "12px",
          overflow: "auto",
        },
      }}
    >
      <h2 className="text-xl font-bold text-gray-900 mb-2">
        Dish added successfully 🎉
      </h2>

      <p className="text-gray-600 mb-6">
        Would you like to add another dish?
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={onNo}
          className="px-4 py-2 border rounded-lg hover:bg-gray-50"
        >
          No, I&apos;m done
        </button>
        <button
          onClick={onYes}
          className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primaryDark"
        >
          Yes, add another
        </button>
      </div>
    </Modal>
  );
};

export default AddAnotherDishModal;
